import SDK from '@yxim/nim-web-sdk'
export default {
  loginIM,
  logout,
  loginYunXinChatRoom,
  sendTextMsg,
  onSendP2PMsg,
  setMsgListener,
  setImStatusListener,
  setMemberMsgListener
}

var nim = null
var chatroom = null
var loginUserInfo = {}

// 设置监听
var imStatusListener
function setImStatusListener (cb) {
  imStatusListener = cb
}

var imMsgListener
function setMsgListener (cb) {
  imMsgListener = cb
}

var memberMsgListener
function setMemberMsgListener (cb) {
  memberMsgListener = cb
}
// appKey: data.appKey,
// account: data.fans_id,
// token: data.token,
// chatroomId: data.chatroomId,
// chatroomAddresses: data.address,
// quickReconnect: true,
// tags: data.tags,

function loginIM (data) {
  console.error('loginIM2222=', data)
  loginUserInfo = data
  nim = SDK.NIM.getInstance({
    debug: false, // 是否开启日志，将其打印到console。集成开发阶段建议打开。
    appKey: data.appKey,
    account: data.fans_id,
    token: data.yxToken,
    authType: 1,
    db: true, // 若不要开启数据库请设置false。SDK默认为true。
    // privateConf: {}, // 私有化部署方案所需的配置
    onconnect: onConnect,
    onwillreconnect: onWillReconnect,
    ondisconnect: onDisconnect,
    onsyncdone: onSyncdone,
    onerror: onError,
    onmsg: function (msg) {
      console.error('私聊消息', msg)
      if (msg.text) {
        memberMsgListener && memberMsgListener(JSON.parse(msg.text))
      }
      
    }
  })
  // nim.setOptions({token:data.yxToken})
}

function logout () {
  if (nim) {
     nim.logout()
  }
  if (chatroom) {
    chatroom.logout()
  }
}

// IM 回调
function getChatroomAddressDone (error, obj) {
  console.log('获取聊天室地址' + (!error ? '成功' : '失败'), error, obj)

  // 非匿名方式登录
  if (!error) {
    console.error('loginUserInfo', loginUserInfo)
    chatroom = SDK.Chatroom.getInstance({
      appKey: loginUserInfo.appKey,
      account: loginUserInfo.fans_id,
      token: loginUserInfo.yxToken,
      loginAuthType:1,
      chatroomId: loginUserInfo.chatroomId,
      chatroomAddresses: obj.address,
      tags: loginUserInfo.tags,
      chatroomEnterCustom: `{"header":"${loginUserInfo.header}"}`,
      notifyTargetTags: '{"tag": ".*", "matchType": "regex"}',
      chatroomCustom: JSON.stringify(loginUserInfo.custom),
      onconnect: (obj)=>{
        console.log('进入聊天室', obj)
        try {
          imMsgListener && imMsgListener({
            module: 'system_message_group_introduction',
            content: JSON.parse(obj.chatroom.custom)
          })
        } catch (error) {}
      },
      onerror: (error1)=>{
        console.log('发生错误',error1)
      },
      onwillreconnect: (error1) => {
        console.log('即将重连', error1)
      },
      ondisconnect: (error1)=>{
        if (error1) {
          switch (error1.code) {
            // 账号或者密码错误, 请跳转到登录页面并提示错误
            case 302:
              break;
            // 被踢, 请提示错误后跳转到登录页面
            case 'kicked':
              if (imStatusListener) {
                imStatusListener({'error': 'kicked'})
              }
              break
            default:
              break
          }
        }
      },
      // 消息
      onmsgs: (msgs)=>{
        console.log('收到聊天室消息', msgs)
        for (let index = 0; index < msgs.length; index++) {
          const element = msgs[index]
          if (element.type === 'text' && element.text) {
            imMsgListener && imMsgListener(JSON.parse(element.text),element)
          }else if (element.type === 'notification') {
            if (element.attach.type === 'updateChatroom') {
              getChatroomInfo()
            }
          }
        }
      },
      // 用户标签更新
      onTagsUpdate: (Tags)=>{
        console.log('收到更新的标签', Tags)
      }
    })
    // chatroom.setOptions({
    //   token: loginUserInfo.yxToken
    // });
  }
}

// 获取聊天室信息
function getChatroomInfo () {
  if (chatroom) {
    chatroom.getChatroom({
      done: (error, obj) => {
        console.log('获取聊天室信息' + (!error ? '成功' : '失败'), error, obj)
        if (!error) {
          try {
            imMsgListener && imMsgListener({
              module: 'system_message_group_introduction',
              content: JSON.parse(obj.chatroom.custom)
            })
          } catch (error) {}
        }
      }
    })
  }
}

function loginYunXinChatRoom (data) {
  chatroom = SDK.Chatroom.getInstance({
    debug: false,
    appKey: data.appKey,
    account: data.fans_id,
    token: data.yxToken,
    loginAuthType:1,
    chatroomId: data.chatroomId,
    chatroomAddresses: data.address,
    quickReconnect: true,
    notifyTargetTags: '{"tag": ".*", "matchType": "regex"}',
    tags: data.tags,
    chatroomEnterCustom: `{"header":"${data.header}"}`,
    chatroomCustom: JSON.stringify(data.custom),
    onconnect: (obj) => {
      console.log('================ 进入聊天室', obj)
      // if (ImLogListener) {
      //   ImLogListener('云信进入聊天室', obj)
      // }
    },
    onerror: (error, obj) => {
      console.log('================ 聊天室发生错误', error, obj)
      // if (ImLogListener) {
      //   ImLogListener('云信聊天室发生错误', error)
      // }
      // if (ImNoConnectListener) {
      //   ImNoConnectListener()
      // }
    },
    onwillreconnect: (obj) => {
      // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
      console.log('================= 聊天室即将重连', obj)
      // if (ImLogListener) {
      //   netChecker()
      //   ImLogListener('云信聊天室即将重连', obj)
      // }
    },
    ondisconnect: (error) => {
      console.log('================== 聊天室连接断开', error)
      // if (ImLogListener) {
      //   netChecker()
      //   ImLogListener('云信聊天室连接断开', error)
      // }

      if (error) {
        switch (error.code) {
          // 账号或者密码错误, 请跳转到登录页面并提示错误
          // case 302:
          //   break
          // 被踢, 请提示错误后跳转到登录页面
          case 'kicked':
            if (imStatusListener) {
              imStatusListener({'error': 'kicked'})
            }
            break
          default:
            if (imStatusListener) {
              imStatusListener({'error': 'noconnect'})
            }
            break
        }
      }
    },
    // 消息
    onmsgs: (msgs) => {
      console.log('================= 收到聊天室消息', msgs)
    }
  })

  // chatroom.setOptions({
  //   token: data.yxToken
  // });
}

// function getChatroomMembersDone (error, obj) { // 获取聊天室列表
//   console.log('获取聊天室成员' + (!error ? '成功' : '失败'), error, obj.members)
// }

// function getChatroomMembers () {
//   chatroom.getChatroomMembers({
//     guest: true,
//     limit: 100,
//     done: getChatroomMembersDone
//   })
// }

function onConnect () {
  console.log('连接成功')
}

function onSyncdone () {
  console.log('初始化同步完成的回调')
  nim.getChatroomAddress({
    chatroomId: loginUserInfo.chatroomId,
    done: getChatroomAddressDone
  })
}

function onWillReconnect (obj) {
// 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
  console.log('即将重连')
  console.log(obj.retryCount)
  console.log(obj.duration)
}

function onDisconnect (error) {
  // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
  console.log('丢失连接')
  console.log(error)
  if (error) {
    switch (error.code) {
      // 账号或者密码错误, 请跳转到登录页面并提示错误
      case 302:
        break
        // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
      case 417:
        break
        // 被踢, 请提示错误后跳转到登录页面
      case 'kicked':
        if (imStatusListener) {
          imStatusListener({'error': 'kicked'})
        }
        break
      default:
        break
    }
  }
}
function onError (error) {
  console.log('错误IM', error)
}
// 发送私聊消息
function onSendP2PMsg (text, fansId) {
  nim.sendText({
    scene: 'p2p',
    to: `${fansId}`,
    text: text,
    done: () => {
      console.log('发送私聊消息成功')
    }
  })
}

// 发送消息
function sendTextMsg (text) {
  var text = JSON.stringify(text)
  chatroom.sendText({
    text: text,
    done: () => {
      console.log('发送陈宫')
    }
  })
}


// WEBPACK FOOTER //
// ./src/kits/im/yunxinim.js